/* eslint-disable no-unused-vars */
<template>
  <div class="page home">
    <transition
      appear
      name="opbouwanimatie"
      mode="out-in"
      v-bind:css="false"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:after-enter="afterEnter"
      v-on:enter-cancelled="enterCancelled"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
      v-on:after-leave="afterLeave"
      v-on:leave-cancelled="leaveCancelled"
    >
      <main>
        <div class="ovalyellow"></div>
        <div class="citybg"></div>
        <div class="ovalgreen"></div>
        <div class="ornamentline"></div>
        <levensweg-header icon="?"></levensweg-header>
        <div class="introcontainer">
          <div class="leftintroblok">
            <img
              src="./../assets/img/introbeeld.svg"
              class="introbeeld hidden-sm visible-md"
            />
          </div>
          <div class="rightintroblok">
            <h2 class="titleslide">Quels sont tes projets de vie?</h2>
            <p class="bodyslide">
              Étudier, voyager, faire carrière ou avoir des enfants tout de
              suite ? Quels sont tes projets de vie?
            </p>
            <levensweg-button
              class="startknop"
              label="Commencer"
              color="blue right"
              link="/stap1"
            />
          </div>
        </div>
      </main>
    </transition>
  </div>
</template>

<script>
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";
//import Revealer from './../Revealer';
import { TimelineMax, Elastic, Sine, Expo } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
// Force CSSPlugin to not get dropped during build
//need this to avoid tree shake of CSSPlugin
/* eslint-disable */
const plugins = [CSSPlugin];
/* eslint-enable */
let tl;

export default {
  components: {
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton,
  },
  mounted() {},
  beforeDestroy() {},

  methods: {
    // --------
    // ENTERING
    // --------

    beforeEnter: function () {
      // ...
    },
    // the done callback is optional when
    // used in combination with CSS
    enter: function (el, done) {
      tl = new TimelineMax({ paused: true });

      //get ornament line height
      const ornaHeight = document.querySelector(".ornamentline").clientHeight;
      const ornaWidth = document.querySelector(".ornamentline").clientWidth;
      //console.log(`De ornament width = ${ornaWidth} en de height = ${ornaHeight}`);
      tl.add("enter");
      tl.from(".titleslide", 1, { opacity: 0, ease: Sine.easeIn })
        .from(".titleslide", 0.7, { x: 50, ease: Sine.easeOut }, "-=0.8")
        .fromTo(
          ".ornamentline",
          1.5,
          { clip: `rect(0px, ${ornaWidth}px, 0px, 0px)` },
          {
            clip: `rect(0px, ${ornaWidth}px, ${ornaHeight}px, 0px)`,
            ease: Expo.easeOut,
          },
          "-=0.5"
        )
        //.fromTo(".ornamentline",0.8,{clipPath:'inset(0 0 100% 0)'},{clipPath:'inset(0 0 0% 0)', ease:Expo.easeOut},"-=0.5")
        .from(
          ".bodyslide",
          0.8,
          { x: 50, opacity: 0, ease: Expo.easeOut },
          "-=0.6"
        )
        .from(".startknop", 0.5, { opacity: 0, ease: Sine.easeIn }, "-=0.6")
        .fromTo(
          ".ovalyellow",
          1,
          { scale: 0, transformOrigin: "0% 0%" },
          { scale: 1, ease: Elastic.easeOut.config(1, 0.8) },
          "-=0.7"
        )
        .fromTo(
          ".ovalgreen",
          1,
          { scale: 0, transformOrigin: "100% 100%" },
          { scale: 1, ease: Elastic.easeOut.config(1, 0.8) },
          "-=0.8"
        );

      tl.timeScale(1.3);
      tl.delay(0.9);
      tl.eventCallback("onComplete", () => {
        //console.log("intro Home ready");
        done();
      });
      tl.play();
    },
    afterEnter: function () {
      // ...
    },
    enterCancelled: function () {
      // ...
    },

    // --------
    // LEAVING
    // --------

    beforeLeave: function () {
      // ...
      //console.log("leaving home screen");
    },
    // the done callback is optional when
    // used in combination with CSS
    leave: function (el, done) {
      // ...
      //console.log("leaving home screen");
      done();
    },
    afterLeave: function () {
      // ...
      //console.log("leaving home screen");
    },
    // leaveCancelled only available with v-show
    leaveCancelled: function () {
      // ...
    },
  },
};
</script>

<style>
.hidden-sm {
  display: none;
}

.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
  /*clip: rect(0px, 1000px, 0px, 0px);*/
}

.ovalyellow {
  background-image: url("../assets/img/homehalfovalyellow.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 106px;
  height: 273px;
  position: absolute;
  z-index: -2;
}
.ovalgreen {
  background-image: url("../assets/img/homehalfovalgreen.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 97px;
  height: 327px;
  position: absolute;
  bottom: 25px;
  right: 0px;
  z-index: -1;
}

.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -10;
  position: absolute;
}

.titleslide {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin: 14.4rem 14.6% 0 14.6%;
  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 14.6% 0 14.6%;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
    height: 550px;
  }
}

/*medium*/
@media only screen and (min-width: 992px) {
  .page {
    height: 700px;
  }

  .visible-md {
    display: inline;
  }

  .introcontainer {
    display: flex;
    align-items: flex-end;
  }

  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .introcontainer div {
    flex: 50%;
  }
  .leftintroblok {
    text-align: right;
    margin-right: 7.7rem;
  }

  .leftintroblok img {
    width: 60%;
    height: 60%;
  }

  .titleslide {
    /*CSS EDIT FRENCH VERSION */
    /*width: 32.5rem;*/
    margin-left: 0;
    /*margin: 10.5rem 31.91%  0 54.83%;*/
  }

  .bodyslide {
    margin-left: 0;
    /*margin: 5.1rem 31.91%  0 54.83%;*/
  }
  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}
/* large */
@media only screen and (min-width: 1200px) {
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .leftintroblok img {
    width: 430px;
    height: 398px;
    margin-bottom: -7rem;
  }

  .ovalgreen {
    width: 263px;
    height: 545px;

    background-image: url("../assets/img/ovalgreen_big.svg");
    bottom: 0;
    right: 0;
  }

  .ovalyellow {
    background-image: url("../assets/img/ovalyellow_big.svg");
    width: 263px;
    height: 430px;
    left: 0;
    top: 0;
  }

  .page.home {
    height: 768px;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .introcontainer {
    margin-top: 10.5rem;
  }

  .titleslide {
    font-size: 8rem;
    margin: 0;
  }
  .bodyslide {
    font-size: 1.5rem;
    width: 34.2rem;
    margin-top: 5.1rem;
    margin-bottom: 4rem;
  }
}
</style>
